import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { withMedia } from 'react-media-query-hoc';
import BackButton from './back-button';
import * as styles from './generic-panel.style';

// Displays title and description
// Also displays legend if provided
import { jsx as ___EmotionJSX } from "@emotion/core";
var GenericPanel = props => ___EmotionJSX("div", {
  css: styles.genericPanel
}, props.media.mobile && ___EmotionJSX("p", {
  css: styles.title
}, props.title), !isEmpty(props.legend) && ___EmotionJSX("ul", {
  css: styles.legendList({
    columns: props.legendColumns
  })
}, props.legend.map(item => ___EmotionJSX("li", {
  key: item.name,
  title: item.description,
  css: styles.legendListItem
}, ___EmotionJSX("span", {
  css: styles.legendListItemSymbol(item.colour)
}), ___EmotionJSX("span", {
  css: styles.legendListItemLabel
}, item.name)))), ___EmotionJSX("div", {
  css: styles.content
}, !props.media.mobile && ___EmotionJSX("p", {
  css: styles.title
}, props.title), ___EmotionJSX("div", {
  css: styles.description,
  dangerouslySetInnerHTML: {
    __html: props.description
  } // eslint-disable-line react/no-danger
}), ___EmotionJSX(BackButton, {
  onClick: props.onBack
})));
GenericPanel.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  legend: PropTypes.arrayOf(PropTypes.shape({
    colour: PropTypes.string,
    description: PropTypes.string,
    name: PropTypes.string
  })),
  legendColumns: PropTypes.number,
  onBack: PropTypes.func.isRequired,
  media: PropTypes.shape({
    mobile: PropTypes.bool
  })
};
GenericPanel.defaultProps = {
  legend: [],
  legendColumns: 2,
  media: {}
};
export default withMedia(GenericPanel);